<template>
  <div class="syndesi-progress-loader">
    <div class="content">
      <img
        src="../../../assets/syndesi/smartsaver-ai.svg"
        class="syndesi-logo"
        alt="Syndesi Logo"
      >
      <progress-stage-loader
        :current-stage="props.progressState.currentStage"
        :completed-stages="props.progressState.completedStages"
        :error="props.progressState.error"
        :status-message="props.progressState.statusMessage"
        :flow-config="syndesiFlowConfig"
        force-font-family="CircularStdBook"
      />
    </div>
  </div>
</template>

<script setup>
import Segment from '../../../Segment';
import ProgressStageLoader from '../../Common/ProgressStageLoader.vue';

const props = defineProps({
  jobId: {
    type: String,
    required: true,
  },
  progressState: {
    type: Object,
    required: true,
  },
});

// Syndesi-specific flow configuration with custom messaging
const syndesiFlowConfig = {
  title: 'Analyzing your financial data',
  description: 'This might take up to a few minutes to complete.',
  stageMessages: {
    scrape: 'Securely collecting your financial data from connected accounts...',
    versionUpdate: 'Processing and validating your account information...',
    featurama: 'Analyzing spending patterns to identify optimization opportunities...',
    otis: 'Generating personalized financial recommendations and insights...',
  },
};

// Track when component is entered
Segment.trackUserGot('SyndesiProgressLoaderEntered');
</script>

<style lang="scss" scoped>
.syndesi-progress-loader {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #FCF7ED; // Syndesi's cream background
}

.content {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  padding: 20px;
}

.syndesi-logo {
  width: 50%;
  margin-top: 25px;
  margin-bottom: 20px;
  max-width: 200px;
}
</style>
